import { get as getStoreValue, writable } from "svelte/store";

// Create a Svelte writable store to hold the translations
const translationsStore = writable<Translations>({});

// Function to set translations
function set(newTranslations: Translations): void {
  translationsStore.set(newTranslations);
}

// Function to get a translation by key with placeholders
function get(key: TranslateKeys, ...args: (string | number)[]): string {
  const translations = getStoreValue(translationsStore);
  let translation = translations[key] || "Missing";

  // Replace placeholders with arguments
  args.forEach((value, index) => {
    translation = translation.replace(
      new RegExp(`\\{${index}\\}`, "g"),
      String(value),
    );
  });

  return translation;
}

// Export the helper
export const t = { set, get };
